import { HttpTypes } from '@medusajs/types';
import { clx } from '@medusajs/ui';

import type { EnhancedStorePromotion } from '@marxbiotech/shared-types/medusa';
import EmptyCartMessage from '@modules/cart/components/empty-cart-message';
import DiscountTemplate from '@modules/cart/templates/discount';
import ItemsTemplate from '@modules/cart/templates/items';
import OrderSummary from '../order-summary';

interface CheckoutCartProps {
  cart: HttpTypes.StoreCart | null;
  promotions?: EnhancedStorePromotion[];
  showImg?: boolean;
  showIdx?: boolean;
  orderSummaryClassName?: string;
}

const CheckoutCart = ({
  cart,
  promotions,
  orderSummaryClassName,
  ...props
}: CheckoutCartProps) => {
  return (
    <div>
      {cart?.items?.length ? (
        <div className="flex flex-col bg-white">
          <ItemsTemplate items={cart?.items} {...props} />
          <DiscountTemplate
            promotions={promotions}
            itemTotal={cart?.item_total || 0}
            currencyCode={cart?.currency_code || 'twd'}
            freeshippingPromotion={
              promotions?.find((promotion) =>
                /^FREESHIPPING/.test(promotion.code || '')
              ) || null
            }
          />
          <OrderSummary
            cart={cart}
            className={clx(orderSummaryClassName, 'ml-auto mt-4')}
          />
        </div>
      ) : (
        <div>
          <EmptyCartMessage />
        </div>
      )}
    </div>
  );
};

export default CheckoutCart;
